import React, { useEffect } from 'react';

import navbarReduce from '../../shared/data/navbar/navbarReduce';
import Page from 'Components/Page';
import withAuthentication from 'Components/withAuthentication';
import TabVacationCalendar from '../Colleagues/components/TabVacationCalendar/TabVacationCalendar';
import ReactGA from 'Shared/analytics';
import { Redirect, Route, useLocation } from 'react-router-dom';
import AppSwitch from 'Components/AppSwitch';

const Team = ({ profileData }) => {
  const path = useLocation();

  useEffect(() => {
    ReactGA.pageview(path.pathname, 'Team vacations');
  }, [path]);

  const tabRouter = (
    <>
      <AppSwitch>
        <Route path="/customer/team/" exact render={() => <Redirect to="/customer/team/vacations/" />} />
        <Route path="/customer/team/vacations/" component={TabVacationCalendar} />
      </AppSwitch>
    </>
  );

  return (
    <Page
      props={{
        titleProps: {
          text: 'Team',
        },
        navigation: {
          variant: 'tabs',
          tabsProps: {
            tabs: [
              {
                id: 'vacations',
                label: 'VACATIONS',
              },
            ],
          },
        },
        navbarProps: {
          points: navbarReduce(profileData),
          activePointId: 'team',
        },
        content: tabRouter,
      }}
    />
  );
};

export default withAuthentication(Team);
